import React, { useState, useEffect } from 'react';

import Button from '@mui/material/Button';
import './Code.css';
// import PropTypes from 'prop-types';
import Farbe from './components/Farbe';
import axios from 'axios';



export default function Code({ setValidation }) {

    
    async function verifyCode() {

        await localStorage.setItem('code', document.getElementById('input').value)

        setValidation(true)

    }


    useEffect(() => {
        let ls_code = localStorage.getItem('code');
        if (ls_code !== null) {
            setValidation(true)
        }
    }, []);

    
//   grun und weis, button green

    return (
        <div  id="wrapper_init">

            <div id="login_box">
                <div id="upper">
                    <div id="uppercontent">
                        Bitte CODE eingeben<p />
                        <input type="text" id="input" placeholder="#CODE#"

                        />
                    </div>
                </div>
                <div className="submit" id="lower">
                    {<div onClick={() => verifyCode()}><Button className="submit" variant="outlined">Verifizieren</Button></div>}

                </div>
            </div>

        </div>)
}

// Code.propTypes = {
//     setToken: PropTypes.func.isRequired
//   };